export default __webpack_public_path__ + "static/media/ninja.8a49bfb6.gif";